<template>
	<div style="display: grid; gap: 1em; grid-template-columns: repeat(3, 1fr); ">
		<template v-if="status=='Pending'">
			<button type="button" class="booking_item_status time" v-on:click="toggleSupplierActivityForm('time')"><i class="fal fa-clock"></i>Suggest Time</button>
			<button type="button" class="booking_item_status accept" v-on:click="toggleSupplierActivityForm('accept')"><i class="fal fa-check-circle"></i>Accept Booking</button>
			<button type="button" class="booking_item_status decline" v-on:click="toggleSupplierActivityForm('decline')"><i class="fal fa-times-circle"></i>Decline Booking</button>
		</template>
		<template v-if="status=='Accepted'">
			<span class="booking_item_status accepted"><i class="fas fa-check-circle"></i>Accepted</span>
		</template>
		<template v-if="status=='Declined'">
			<span class="booking_item_status declined"><i class="fas fa-check-circle"></i>Declined</span>
		</template>
		<template v-if="suggested_time">
			<span class="suggested_time">Suggested Time: {{ suggested_time }}</span>
		</template>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'item',
		'uuid'
	],

	data: () => {
		return {
			status: '',
			suggested_time: null
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
		this.status = this.item.status
		this.suggested_time = this.item.raw_suggested_time
	},

	methods: {

		...mapActions(['addAlert']),

		toggleSupplierActivityForm: function(action){
			this.$root.$refs.supplieractivityform.toggleSupplierActivityForm(this.uuid, this.item, action);
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		}

	}
};
</script>